"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// The fold's pace: the same as the sidebar's width (ConsoleShell's), so
// everything inside the column moves with the column.
const FOLD_MOTION = {
  default: "220ms",
  "@media (prefers-reduced-motion: reduce)": "0s"
}; // Where a folded link's glyph sits: centered in the rail, which is the
// sidebar's folded width less its padding (ConsoleShell's) — 2.75rem —
// around a 20px glyph.
const FOLDED_GLYPH_INSET = "calc((2.75rem - 20px) / 2)";
const styles = exports.styles = {
  nav: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    flexGrow: "x1iyjqo2",
    gap: "xru8eyw",
    rowGap: null,
    columnGap: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    transitionProperty: "xy6w8to",
    transitionDuration: "xpceaqw x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  navCollapsed: {
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  group: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x73f2yu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  groupPinnedToEnd: {
    marginTop: "xr1yuqi",
    $$css: true
  },
  groupAfterFirst: {
    paddingTop: "xexx8yu",
    borderTopWidth: "x178xt8z",
    borderTopStyle: "x13fuv20",
    borderTopColor: "x1v8p93f",
    transitionProperty: "x9ony9x",
    transitionDuration: "xpceaqw x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  groupDivided: {
    paddingTop: "x1q57ora",
    borderTopColor: "x1a6tffd",
    $$css: true
  },
  headingFold: {
    display: "xrvj5dj",
    gridTemplateRows: "x1tu4anv",
    opacity: "x1hc1fzr",
    marginBottom: "xat24cr",
    transitionProperty: "x10ay56i",
    transitionDuration: "xpceaqw x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  headingFolded: {
    gridTemplateRows: "xihq33y",
    opacity: "xg01cxk",
    marginBottom: "x1fi8ia4",
    $$css: true
  },
  heading: {
    minHeight: "x2lwn1j",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    whiteSpace: "xuxw1ft",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    paddingBottom: "xes99ow",
    paddingLeft: "x79ra4s",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    fontFamily: "xzjhs3a",
    fontSize: "xboafo0",
    fontWeight: "x1s688f",
    letterSpacing: "x1dgsrnt",
    textTransform: "xtvhhri",
    color: "xldsce3",
    $$css: true
  },
  list: {
    listStyle: "xe8uvvx",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x1enigpx",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  link: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x5m0csh",
    rowGap: null,
    columnGap: null,
    minHeight: "xgbkey0",
    paddingLeft: "x79ra4s",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x33uob6",
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontSize: "x1ksoetq",
    color: "x10kmngs",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    backgroundColor: "xjbqb8w x14sfa1n",
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x2ssjo2",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    transitionProperty: "xd5de8g",
    transitionDuration: "x1pa6gdw x12w9bfk",
    $$css: true
  },
  linkCollapsed: {
    paddingLeft: "x10z6brn",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1xpa7k",
    gap: "xxhr3t",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  label: {
    flexGrow: "x1iyjqo2",
    flexShrink: "xs83m0k",
    flexBasis: "x1r8uery",
    minWidth: "xeuugli",
    whiteSpace: "xuxw1ft",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    opacity: "x1hc1fzr",
    transitionProperty: "x19991ni",
    transitionDuration: "xpceaqw x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  labelHidden: {
    opacity: "xg01cxk",
    $$css: true
  },
  linkActive: {
    color: "x19p3n1p",
    fontWeight: "x1s688f",
    backgroundColor: "xj8nutk x86b68t",
    $$css: true
  },
  footButton: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x5m0csh",
    rowGap: null,
    columnGap: null,
    width: "xh8yej3",
    minHeight: "xgbkey0",
    paddingLeft: "x79ra4s",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x33uob6",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontFamily: "x1wl88yq",
    fontSize: "x1ksoetq",
    textAlign: "xdpxx8g",
    color: "x10kmngs",
    backgroundColor: "xjbqb8w x14sfa1n",
    cursor: "x1ypdohk",
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x2ssjo2",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    transitionProperty: "xd5de8g",
    transitionDuration: "x1pa6gdw x12w9bfk",
    $$css: true
  }
};